import { cn } from '@/lib/cn'

type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement> & {
  hint?: string
}

export function Label({ className, hint, children, ...props }: LabelProps) {
  return (
    <label className={cn('block text-sm font-medium text-slate-200', className)} {...props}>
      <span>{children}</span>
      {hint ? <span className="ml-2 text-xs text-slate-400">{hint}</span> : null}
    </label>
  )
}
